/* ======================================= ACCESIBILITY CLASS ========================================================== */
function Accessible_Bundle(args){
    this.options = args;
    this.interactives = ['a','button','input','textarea'];
    this.anchor_to_image = document.querySelectorAll('a[href$=".jpg"],a[href$=".png"]');
    this.stylesheet = document.createElement('style');
    this.main_menu = args.main_menu;
    this.sub_menu = args.sub_menu;
    this.focus_style = "1px solid #4da0fe !important";
	this.start = (function(){
		for(var key in this){
			if(typeof this[key] === "function"){
				this[key]();
			}
		}
	}.bind(this))();
}
Accessible_Bundle.prototype.methods = {
	triggerMouseEvent : function(node, eventType) {
		var clickEvent = document.createEvent('MouseEvents');
		clickEvent.initEvent(eventType, true, true);
		node.dispatchEvent(clickEvent);
	},
    getStyle : function(node, style_prop){
        return window.getComputedStyle(node,null).getPropertyValue(style_prop);
    },
    parentsUntil : function(el, parent_name){
        var parent = el.parentNode;
        var con = parent.className.indexOf(parent_name) === -1 || parent_name.toUpperCase() != parent.parentNode.nodeName.toUpperCase();
        while(con){
            if(parent.nodeName === "FORM" || parent.nodeName === "BODY" || con){
                break;
            }
            parent = parent.parentNode;
        }
        return parent;
    }, 
    viewport : function(){
		var e = window, a = 'inner';
		if (!('innerWidth' in window )) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
    },
    above : function(el,event){
        var cx = event.clientX,
            cy = event.clientY;
        return !((el.getBoundingClientRect().right < cx) || (el.getBoundingClientRect().left > cx) || 
            (el.getBoundingClientRect().top > cy) || (el.getBoundingClientRect().bottom < cy));
    }

};
Accessible_Bundle.prototype.methods.upper = Accessible_Bundle;
Accessible_Bundle.prototype.make_stylesheet = function(){

    /*appends a stylesheet to the <head> and places some accesibility styles inside */

    this.interactives.forEach(function(item){
         var add_tab_highlight = document.createTextNode(".tab_navigation "+ item +":focus {outline:"+ this.focus_style +";}")                         
         this.stylesheet.appendChild(add_tab_highlight);
    }.bind(this));
   
    var obscure_style = document.createTextNode(
        '.obscure {position:absolute;top:-9999999999px;}'+
        '.offScreen {margin:0px;height:0px;overflow:hidden;display:block;position:absolute;display:table-cell;width:0;}'+
		'.onfocus {outline:' + this.focus_style + ';}'
    );
    this.stylesheet.appendChild(obscure_style);
    this.stylesheet.id = "Accessible_Bundle_Stylesheet";
    document.head.appendChild(this.stylesheet);

};
Accessible_Bundle.prototype.tab_navigation = function(){

    /* sets up styled highlights on focused elements when navigating with tab key */

    var it = this;
	document.addEventListener('keyup',function(e){
		if(e.which === 9){
			if(document.body.className.indexOf(' tab_navigation') === -1){
				document.body.className += " tab_navigation";
			}
		}
	});
	document.addEventListener('click',function(e){
		document.body.className = document.body.className.replace(" tab_navigation","");
	});
};
Accessible_Bundle.prototype.display_sub_menu = function(){

    /*makes sure that sub menus are displayed on the focus of the sub's parent's <a> element */

	var menu = document.querySelectorAll(this.main_menu);
    if(!menu.length) return;
    var it = this;
    [].forEach.call(menu,function(el){
       
        var a = el.querySelectorAll( this.main_menu + ' > li > a');
        var it = this;
        [].forEach.call(a,function(ael){
            var sub = ael.parentNode.querySelector(it.sub_menu);
            if(sub) sub.style.display = "";
            ael.addEventListener('focus',function(){
                var presib = ael.parentNode.previousElementSibling;
                if(presib){
                    var presib_sub = presib.querySelector(it.sub_menu);
                    if(presib_sub){
                        presib_sub.style.display = "";
                        presib_sub.style.visibility = "";
                    }
                }
                if(sub) {
                    sub.style.display = "block";       
                    sub.style.visibility = "visible";
                                
                }
            });
        });

    }.bind(this));
    document.addEventListener('click',function(e){
        var presib_sub = document.querySelectorAll(it.sub_menu);
        if(!presib_sub.length) return; 
        var psl = presib_sub.length;
        for(var i = 0; i < psl; i++){
            if(!it.methods.above(presib_sub[i],e)){
                presib_sub[i].style.display = "";
                presib_sub[i].style.visibility = "";
            }
        }
    });
};
Accessible_Bundle.prototype.click_on_button_on_focus = function(){
    var btns = document.querySelectorAll('button , a[href="javascript:void(0)"]');
	/*componsates if focus element has mousedown event instead of click */
    if(!btns) return;
	var it = this;
    [].forEach.call(btns,function(el){
       
        if(this.methods.getStyle(el,"display") === "none" || this.methods.getStyle(el,"visibility") === "hidden") return;
       
        el.addEventListener('focus',function(){
            el.addEventListener('keyup',function(e){
                if(e.which == 13){
					it.methods.triggerMouseEvent(this,'mousedown');
					requestAnimationFrame(function(){
						it.methods.triggerMouseEvent(this,'mouseup');
					}.bind(this));
                }
            });
        });

    }.bind(this));
   
};
Accessible_Bundle.prototype.highlight_focus_on_styled_checkbox = function(){

    /*finds checkboxes with 0 opacity and transforms their focus style to their parent*/
    
    var obscure_checkboxes = document.querySelectorAll('input[type="checkbox"]');
     if(!obscure_checkboxes.length) return;
	
    var it = this;
    obscure_checkboxes = [].filter.call(obscure_checkboxes,function(el){
        return it.methods.getStyle(el,"opacity") === "0";
    });
    if(!obscure_checkboxes.length) return;

    [].forEach.call(obscure_checkboxes,function(el){
		
        el.addEventListener('focus',function(){
			if(el.parentNode.className.indexOf(" onfocus") === -1)el.parentNode.className += " onfocus";
        });
        el.addEventListener('blur',function(){
            el.parentNode.className = el.parentNode.className.replace(' onfocus','');
        });
		el.addEventListener('click',function(){
			if(this.checked === false){
				 el.parentNode.className = el.parentNode.className.replace(' onfocus','');
			}
		});
    });
};

Accessible_Bundle.prototype.print_aria_labels_on_menus = function(){

    /*  menu structure as according to example in 
        http://www.toovya.co.il/web-accessibility/58-definition-of-menus-with-aria-roles
    */
    var menus = document.querySelectorAll(this.main_menu);
    if(!menus.length) return;
    var methods = {
        set_li_attributes : function(lis){
            [].forEach.call(lis,function(li){
                li.setAttribute('role','menuitem');
                var sub_menu = li.getElementsByTagName('ul')[0];
                if(sub_menu) {
                    li.setAttribute('aria-haspopup','true');
                    sub_menu.setAttribute('role','menu');
                }
            });
        }
    };
    [].forEach.call(menus,function(el){
        el.insertAdjacentHTML('beforebegin','<h5 class="offScreen">Menu Bar</h5>');
        el.parentNode.setAttribute('role','navigation');
        el.setAttribute('role','menubar');
        methods.set_li_attributes(el.getElementsByTagName('li'));
    }.bind(this));
};

Accessible_Bundle.prototype.a11y_form = function(){

    /* inserting accesibility helpers to selected forms' elements */

    var forms = document.querySelectorAll(this.options.forms);
    if(!forms.length) return;
    var it = this;
    var methods = {
        print_labels : function(form){
            var inputs = form.querySelectorAll('input:not([type="submit"]):not([type="hidden"]),textarea');
            var  n = new Date().getTime() ;
            [].forEach.call(inputs,function(el){
                /*vars*/
                var id = el.id,
                    label_for_this_el = form.querySelector('label[for="'+id+'"]');
                   
                
                /*print area-required on required fields */
                if(el.hasAttribute('required') && !el.hasAttribute('aria-required')){
                    el.setAttribute('aria-required','true');
                }
                
                /* print label for that input if no valid label*/
                if(it.methods.parentsUntil(el,'label').nodeName != "LABEL"){
                    /* not wrapped in label */
                    if(!label_for_this_el){
                        /* no associated label */
                        
                        if(id === ""){
                            n++;
                            el.id = "input_id_" + n;
                        }
                        var new_label = document.createElement('label');
                        new_label.textContent = el.placeholder ? el.placeholder : el.value;
                        new_label.setAttribute('for',el.id);
                        new_label.className = "obscure";
                        n++;
                        new_label.id = "input_label_id" + n;
                        el.parentNode.appendChild(new_label);
                    }
                    /*update vars*/
                    id = el.id;
                    label_for_this_el = form.querySelector('label[for="'+id+'"]');
                    if(label_for_this_el.id === ""){
                         n++;
                        label_for_this_el.id = "input_label_id" + n;
                    }
                    if(!el.hasAttribute('aria-labelledby')) el.setAttribute('aria-labelledby',label_for_this_el.id);
                    
                } else {
                    /*wrapped in label, but label is empty or has no aria-labelledby attribute*/
                    var wrapping_label =  it.methods.parentsUntil(el,'label');
                    if(wrapping_label.id === ""){
                         n++;
                        wrapping_label.id = "wrapping_label_id_" + n;
                    }
                     
                    if(wrapping_label.textContent.trim() === ""){
                        var label_text = document.createElement('span');
                        label_text.textContent = el.placeholder ? el.placeholder : el.value;
                        label_text.className = "obscure";                        
                        wrapping_label.appendChild( label_text );
                    }
                    if(!el.hasAttribute('aria-labelledby')) el.setAttribute('aria-labelledby',wrapping_label.id);
                }
                
            });
        }
    };
    
    [].forEach.call(forms,function(el){
        el.setAttribute('novalidate','');
        methods.print_labels(el);
    });
};
Accessible_Bundle.prototype.google_recaptcha = function(){
    var recaptcha_keys = document.querySelectorAll('.recaptcha_key');
    if(!recaptcha_keys.length) return;
    /*load the google api recpatcha script*/
    var script = document.createElement('script');
    script.src = "https://www.google.com/recaptcha/api.js?hl=iw";
    document.body.appendChild(script);
    /* */
    var it = this;
    var methods = {
        recaptcha_responsive : function(){
            var recaptchas = document.querySelectorAll('.g-recaptcha');
            if(!recaptchas.length) return;
            var methods = {
                scale : function(el,by){
                    el.style.transform = "scale("+by+")";
                    el.style.webkitTransform = "scale("+by+")";
                    el.style.msTransform = "scale("+by+")";
                },	
                start : function(el){
                    var par = el.parentNode,
                        goal_width_in_px = par.clientWidth,
                        el_width = el.children[0] ? el.children[0].clientWidth : 0,
                        formula = goal_width_in_px / el_width;
                    if(formula > 1) formula = 1;
                    this.scale(el,formula);
                    par.style.height = el.clientHeight * formula + "px"; 
                },
                make : function(){
                    [].forEach.call(recaptchas,function(el){
                        this.start(el);
                    }.bind(methods));
                }
            };
            function recourse(){
                methods.make();
                setTimeout(recourse,30);
            }recourse();
        },
        recaptcha_css : function(){
            var css = document.createTextNode(
                '.gr_hold {	margin-top: 10px;}'+
                '.g-recaptcha {transform-origin: right top;-webkit-transform-origin: right top;margin:8px 0 0 0;}'+
                '.gr_hold {	max-width:304px;margin:0 auto 9px;}'
            );
            it.stylesheet.appendChild(css);
        }
    };
    script.onload = function(){
        [].forEach.call(recaptcha_keys,function(el){
            el.innerHTML = '<div class="gr_hold loading">' +
                '<div class="g-recaptcha" data-sitekey="' + el.dataset.key + '" data-theme="light"></div>' + 
            '</div>';
        });
        methods.recaptcha_css();
        methods.recaptcha_responsive();
    }
};
Accessible_Bundle.prototype.pagination = function(){
    var pagination = document.querySelectorAll(this.options.pagination);
    if(!pagination.length) return;
    [].forEach.call(pagination,function(el){
        el.setAttribute('role',"navigation");
        el.insertAdjacentHTML('beforebegin','<h5 class="offScreen">Pagination</h5>');
        var links = el.querySelectorAll('a'),
            lil = links.length;
        for(var i = 0; i < lil; i++){
            if(i === 0) {
                links[0].setAttribute('aria-label',"previous page");
            }
            links[links.length - 1].setAttribute('aria-label',"last page");
        }

    });
};

Accessible_Bundle.prototype.sidebr_to_top_on_mombile = function(){
    var options = this.options.push_sidebar_to_top;
    if(typeof options !== "object") return;
    var big_bool = true,
        small_bool = true,
        sidebar = document.querySelector(options.sidebar),
        placer = document.querySelector(options.where_to_put);
        
    if(!sidebar || !placer){
        return; 
    }
    var clone = sidebar.cloneNode(true),
        clone_id = "cloned_sidebar_for_mobile_82374023",
        it = this;
    
    function make(){
        if(it.methods.viewport().width < options.when_to_change){
            if(small_bool){
                placer.insertBefore(clone,placer.children[0]);
                clone.id = clone_id;
                sidebar.style.display = "none";
                small_bool = false;
                big_bool = true;
            }
        } else {
            if(big_bool){
                var exisiting = document.getElementById(clone_id);
                if(exisiting){
                    exisiting.parentNode.removeChild(exisiting);
                }
                sidebar.style.display = "";
                small_bool = true;
                big_bool = false;
            }
        }
    }
    make();
    window.addEventListener('resize',make);
};
Accessible_Bundle.prototype.skip_on_tabs_navigation = function(){
	/* removes access to elemnt on tab navigation */
	var to_skip = document.querySelectorAll(this.options.elems_to_skip_on_tab_navigation);
	if(!to_skip.length) return;
	[].forEach.call(to_skip,function(el){
		el.setAttribute('tabindes','-1');
	});
};
(function(){
   
    var a11y = new Accessible_Bundle({
        main_menu : "#main_menu > ul",
        sub_menu : '.sub-menu',
        forms : '.form_section_form, .top_search',
        pagination : '.pagination',
		elems_to_skip_on_tab_navigation : '.lazy_load,.grad_load'

        
    });
   
})();



// WEBPACK FOOTER //
// ./assets/js/accessible-bundle.js